'use client';

import * as DS from '@aurorasolar/ds';

import { BatteryMode } from '../engine';

type Props = {
  mode: BatteryMode;
  onModeChange: (mode: BatteryMode) => void;
  solarEnabled: boolean;
};

const MODE_DESCRIPTIONS: Record<BatteryMode, string> = {
  ARBITRAGE: 'Charges when grid power is cheap and powers your home when rates peak.',
  BACKUP: 'Holds its charge in reserve so your home stays powered through an outage.',
  SELF_USE: 'Stores your extra solar power for the evening instead of selling it back low.',
};

const MODE_LABELS: Record<BatteryMode, string> = {
  ARBITRAGE: 'Arbitrage',
  BACKUP: 'Backup',
  SELF_USE: 'Self-use',
};

const MODES: BatteryMode[] = ['SELF_USE', 'ARBITRAGE', 'BACKUP'];

export const BatteryModeSelector = ({ mode, onModeChange, solarEnabled }: Props) => {
  const segments = MODES.map((key) => ({ key, label: MODE_LABELS[key] }));

  return (
    <DS.Flex gap={2} w="100%">
      <DS.SegmentedControl
        handleSegmentsSelected={(selectedSegments) => {
          const selected = selectedSegments[0]?.key;
          if (selected) {
            onModeChange(selected);
          }
        }}
        segmentGroupProps={{ id: 'battery-mode' }}
        segments={segments}
        selectedSegmentKeys={[mode]}
      />
      <DS.Text color="uiHelperCopy" text="body12">
        {mode === 'SELF_USE' && !solarEnabled
          ? 'Self-use needs solar to store — turn on solar panels to see savings.'
          : MODE_DESCRIPTIONS[mode]}
      </DS.Text>
    </DS.Flex>
  );
};
